import { Alert, Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export { drawerPaperSx } from "../PlatformUserAccess.styles";

const inviteDrawerHorizontalPadding = (theme) => ({
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
});

/** Full-height column shell for right-anchored side drawers (invite, detail, etc.). */
export const InviteDrawerContent = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$drawerWidth",
})(({ theme, $drawerWidth }) => ({
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
  height: "100%",
  minHeight: 0,
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  width: $drawerWidth,
}));

export const InviteDrawerHeader = styled(Stack)(({ theme }) => ({
  flexShrink: 0,
  marginBottom: theme.spacing(1),
  ...inviteDrawerHorizontalPadding(theme),
}));

export const InviteDrawerScrollBody = styled(Stack)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden",
  gap: theme.spacing(2),
  ...inviteDrawerHorizontalPadding(theme),
}));

export const InviteDrawerFooter = styled(Stack)(({ theme }) => ({
  flexShrink: 0,
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: theme.spacing(1),
  paddingTop: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  ...inviteDrawerHorizontalPadding(theme),
}));

export const InviteDrawerFormSection = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(1.5),
  overflow: "visible",
}));

export const InviteCustomerEditorContainer = styled(Box)({});

export const InviteFormErrorAlert = styled(Alert)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));
